<div class="sidebar">
  <div class="sidebar-header">
    <span class="sidebar-logo">
      <i class="pi pi-bolt text-primary"></i>
      <span class="sidebar-logo-text">Fuel Report</span>
    </span>
  </div>

  <nav class="sidebar-nav">
    <a
      *ngFor="let item of navItems"
      class="nav-item"
      [class.active]="isActive(item.route)"
      (click)="navigate(item.route)">
      <i [class]="item.icon"></i>
      <span>{{ item.label }}</span>
    </a>
  </nav>

  <div class="sidebar-footer">
    <button class="theme-toggle p-button p-button-text" (click)="toggleTheme()">
      <i [class]="isDarkTheme ? 'pi pi-sun' : 'pi pi-moon'"></i>
      <span>{{ isDarkTheme ? 'Light Mode' : 'Dark Mode' }}</span>
    </button>
    <button class="sign-out-btn" (click)="signOut()">
      <i class="pi pi-sign-out"></i>
      <span>Sign Out</span>
    </button>
  </div>
</div>
